import { useExamCenter } from '@exam-center/exam-center-details';
import { MONTH_ORDER } from '@exam-center/exam-event-management';
import { useGetUpcomingExamEventsByExamCenterCodeQuery } from '@exam-center/graphql';
import { useNavigate } from '@exam-center/router';
import { Flex, PaperSection } from '@shared/components';
import { dayjs } from '@shared/utils';
import { useMemo } from 'react';

import { UpcomingExamEvents } from '../../components/';

import { mapExamEventsToExamEventCard } from './utils';

export default function UpcomingExamEventSection() {
  const navigate = useNavigate();
  const { examCenter } = useExamCenter();

  const currentDate = useMemo(() => dayjs(), []);

  const { data: examEventData, loading: isLoading } = useGetUpcomingExamEventsByExamCenterCodeQuery(
    {
      variables: {
        getUpcomingExamEventsByExamCenterCodeInput: {
          examCenterCode: examCenter.code,
        },
      },
      skip: !examCenter.code,
    },
  );

  const examEvents = useMemo(() => {
    const sortedExamEvents = [
      ...(examEventData?.ecGetUpcomingExamEventsByExamCenterCode.examEvents ?? []),
    ].sort((a, b) => {
      return dayjs(a.examStartedAt).isBefore(dayjs(b.examStartedAt)) ? -1 : 1;
    });

    return mapExamEventsToExamEventCard(sortedExamEvents);
  }, [examEventData]);

  const handleViewAllExamEvents = () => {
    const currentYear = currentDate.format('YYYY');
    const currentMonth = MONTH_ORDER[currentDate.month()];
    navigate(`/:examCenterCode/exam-events/years/:year/months/:month`, {
      params: {
        examCenterCode: examCenter.code,
        year: currentYear,
        month: currentMonth,
      },
    });
  };

  return (
    <PaperSection title='รอบสอบที่กำลังมาถึง'>
      <Flex
        sx={(theme) => ({
          flexDirection: 'column',
          p: theme.spacing(6),
          gap: theme.spacing(4),
          alignItems: 'center',
        })}
      >
        <UpcomingExamEvents
          examCenterCode={examCenter.code}
          loading={isLoading}
          examEvents={examEvents}
          onViewAllExamEvents={handleViewAllExamEvents}
        />
      </Flex>
    </PaperSection>
  );
}
